var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "new_sidebar" },
    [
      _c("div", { staticClass: "new_sidebar_head" }, [
        _vm._v("\n    目录\n    "),
        _c(
          "span",
          { staticClass: "tagbar_icon", on: { click: _vm.addTreeItem } },
          [_c("i", { staticClass: "el-icon-plus" })]
        )
      ]),
      _vm._v(" "),
      _c("el-tree", {
        ref: "tree",
        style: { height: _vm.height },
        attrs: {
          data: _vm.treeData,
          "node-key": "id",
          props: _vm.defaultProps,
          "highlight-current": true,
          "default-expanded-keys": [_vm.defaultExpansion],
          draggable: _vm.openDraggable,
          "allow-drop": _vm.allowDrop
        },
        on: { "node-click": _vm.handleNodeClick, "node-drop": _vm.handleDrop },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var node = ref.node
              var data = ref.data
              return _c(
                "div",
                {
                  staticClass: "custom-tree-node",
                  on: {
                    "&mouseover": function($event) {
                      return _vm.treeMouseOver($event, data)
                    },
                    "&mouseleave": function($event) {
                      return _vm.treemouseLeave()
                    },
                    dblclick: function($event) {
                      return _vm.edit(data)
                    }
                  }
                },
                [
                  data.id && data.status != 1
                    ? _c(
                        "span",
                        {
                          staticClass: "custom-tree-node-label",
                          attrs: { title: data.catalogName }
                        },
                        [_vm._v(_vm._s(data.catalogName))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  data.status == 1
                    ? _c("el-input", {
                        ref: "edit" + data.id,
                        staticClass: "nodeInput",
                        staticStyle: { width: "90%", "margin-right": "20px" },
                        attrs: {
                          size: "small",
                          placeholder: "添加目录",
                          maxlength: "100"
                        },
                        on: {
                          blur: function($event) {
                            return _vm.blurEdit(data)
                          }
                        },
                        nativeOn: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.enterBlur($event, data)
                          }
                        },
                        model: {
                          value: data.catalogName,
                          callback: function($$v) {
                            _vm.$set(data, "catalogName", $$v)
                          },
                          expression: "data.catalogName"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.iconIsShow == data.id
                    ? _c(
                        "span",
                        [
                          _c(
                            "el-popover",
                            {
                              attrs: {
                                "popper-class": "zl_sidebar_popper1",
                                placement: "bottom",
                                width: "118",
                                trigger: "click"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "zl_sidebar_popper_btn",
                                  staticStyle: { "user-select": "none" }
                                },
                                [
                                  data.resourceBase &&
                                  !data.resourceBase.length &&
                                  (data.level === 1 || data.level === 2) &&
                                  data.isAddChild === 1
                                    ? _c(
                                        "p",
                                        {
                                          staticClass: "popper_p",
                                          on: {
                                            click: function($event) {
                                              return _vm.append(node, data, 0)
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-circle-plus-outline"
                                          }),
                                          _vm._v(" "),
                                          _c("span", [_vm._v("子目录")])
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  data.catalogParentId &&
                                  data.children &&
                                  !data.children.length &&
                                  data.isAddChild === 1
                                    ? _c(
                                        "p",
                                        {
                                          staticClass: "popper_p",
                                          on: {
                                            click: function($event) {
                                              return _vm.addPage(data)
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-circle-plus-outline"
                                          }),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(_vm._s(_vm.newName))
                                          ])
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass: "popper_p",
                                      on: {
                                        click: function($event) {
                                          return _vm.edit(data)
                                        }
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-edit-outline"
                                      }),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("编辑")])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass: "popper_p",
                                      on: {
                                        click: function($event) {
                                          return _vm.remove(node, data)
                                        }
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-delete"
                                      }),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("删除")])
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              data.id
                                ? _c("span", {
                                    staticClass: "el-icon-more catalogedtordel",
                                    class: {
                                      "tree-node-block":
                                        _vm.iconIsShow == data.id &&
                                        data.status != 1
                                    },
                                    attrs: { slot: "reference" },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.openSelectType.apply(
                                          null,
                                          arguments
                                        )
                                      }
                                    },
                                    slot: "reference"
                                  })
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0e713e81", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e713e81","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/component/new_sidebar.vue
// module id = null
// module chunks = 